// `data` must not be the last parameter: the guest id format ends with ";", which Excel exports and copy/paste
// often drop from the end of a URL, and the QR code then no longer matches the guest. Keep a parameter after it.
const QRCodeAPIBaseURL = 'https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=';
const QRCodeAPIURLSuffix = '&margin=40';
const barcodeAPIBaseURL = 'http://www.barcodes4.me/barcode/c39/';

export function getGuestIdFormatValue(value) {
  return `EVENTOR:GSTID:${value};`;
}

export function getQRCodeURL({ value, defaultGuestIdFormat = false }) {
  let QRCodeData = value;

  if (defaultGuestIdFormat) QRCodeData = getGuestIdFormatValue(value);
  return `${QRCodeAPIBaseURL}${QRCodeData}${QRCodeAPIURLSuffix}`;
}

export function getBarcodeURL(value) {
  return `${barcodeAPIBaseURL}${value}.png`;
}
